/**
 * Sidebar navigation items for the Timesheets module.
 * Provides navigation to activities, overtime rules, pay periods, and daily timecard.
 * Navigation items are feature-flag gated.
 */
// @react-compiler-disable
import { PunchClock, PunchClockOutlined } from '@mui/icons-material';

import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { useFeatureFlag } from '@/common/presentation/hooks/useFeatureFlag';

export interface TimesheetsNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const TimesheetsNavItems = (): TimesheetsNavItemsResult => {
  const isTimesheetsEnabled = useFeatureFlag(FEATURE_FLAGS.TIMESHEETS_PAGE);
  const isActivitiesTabEnabled = useFeatureFlag(FEATURE_FLAGS.TIMESHEETS_ACTIVITIES_TAB);
  const isOvertimeRulesTabEnabled = useFeatureFlag(FEATURE_FLAGS.TIMESHEETS_OVERTIME_RULES_TAB);
  const isPayPeriodsTabEnabled = useFeatureFlag(FEATURE_FLAGS.TIMESHEETS_PAY_PERIODS_TAB);

  const navItems: NavItemType = {
    id: 'timesheets',
    title: 'Timesheets',
    type: 'collapse',
    icon: PunchClockOutlined,
    iconSelected: PunchClock,
    url: '/timesheets?module=timesheets',
    featureFlag: FEATURE_FLAGS.TIMESHEETS_PAGE,
    disabled: !isTimesheetsEnabled || (!isActivitiesTabEnabled && !isOvertimeRulesTabEnabled && !isPayPeriodsTabEnabled),
    children: [
      {
        id: 'activities',
        title: 'Activities',
        type: 'item',
        url: '/timesheets?module=timesheets&submodule=activities',
        featureFlag: FEATURE_FLAGS.TIMESHEETS_ACTIVITIES_TAB
      },
      {
        id: 'overtime-rules',
        title: 'Overtime Rules',
        type: 'item',
        url: '/timesheets?module=timesheets&submodule=overtime-rules',
        featureFlag: FEATURE_FLAGS.TIMESHEETS_OVERTIME_RULES_TAB
      },
      {
        id: 'pay-periods',
        title: 'Pay Periods',
        type: 'item',
        url: '/timesheets?module=timesheets&submodule=pay-periods',
        featureFlag: FEATURE_FLAGS.TIMESHEETS_PAY_PERIODS_TAB
      },
      {
        id: 'daily-time-card',
        title: 'Daily Time Card',
        type: 'item',
        url: '/timesheets?module=timesheets&submodule=daily-time-card',
        featureFlag: FEATURE_FLAGS.TIMESHEETS_DAILY_TIME_CARD_TAB
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default TimesheetsNavItems;
